// extracted by mini-css-extract-plugin
export default {"wrap":"EditLdaPopup_wrap__OywhP","title":"EditLdaPopup_title__1n7zw","submitContainer":"EditLdaPopup_submitContainer__bm2kM"};